// import { Home } from '@mui/icons-material';
import { Routes, Route, Navigate } from 'react-router-dom';
import Coordinator from '../components/coordinator/Coordinator';
import CostEstimate from '../components/costestimate/CostEstimate';
import Dashboard from '../components/dashboard/Dashboard';
import Enrollment from '../components/enrollment/Enrollment';
import Home from '../components/home/Home';
import MainLayout from '../components/Layout/MainLayout';
import Login from '../components/login/Login';
import Register from '../components/register/Register';
import Report from '../components/report/Report';
import Survey from '../components/survey/Survey';
import SchoolDashboard from '../components/school_dashboard/SchoolDashboard';
import PDFSchoolDashboard from '../components/pdf_schooldashboard/PDFSchoolDashboard';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import CostEstimatePdf from '../components/costEstimatePdf/CostEstimatePdf';
import SurveySelection from '../components/surveySelection/SurveySelection';
import SurveyPdf from '../components/surveyPdf/SurveyPdf';
import PDFEnrollment from '../components/pdf_enrollment/PDFEnrollment';
import DashboardPdf from '../components/pdf_dashboard/pdf_dashboard';
// import PDFEnrollment from '../components/pdf_enrollment/PDFEnrollment';
import ManageDistrict from '../components/manageDistrict/ManageDistrict';
import ForgotPassword from '../components/forgotPassword/ForgotPassword';
import PDFReportOrder from '../components/pdf_reportOrder/PDFReportOrder';
import PDFReportOrderMail from '../components/pdf_reportOrderMail/PDFReportOrderMail';
import WdcConnector from '../components/tableau/WdcConnector';

import MaintenancePage from '../components/maintenancePage/MaintenancePage';
import { useParams } from 'react-router-dom';

let registerTitle = "Welcome to CalSCHLS Coordinator Portal"
let otherTitle = "CalSCHLS Coordinator Portal";
let surveyTitle = "Welcome to CalSCHLS Survey";


function RouterConfig() {
    return (
        <Routes>
            <Route element={<PublicRoutes />}>
                <Route index path='/login' element={<Login title={otherTitle} />} />
                <Route path='/register' element={<Register title={registerTitle} />} />
                 {/* <Route index path='/login' element={<MaintenancePage title={otherTitle} />} /> */}
            </Route>
            <Route element={<PrivateRoutes />}>
                <Route element={<MainLayout />}>
                    <Route index={true} path='home' element={<Home title={otherTitle} />} />
                    <Route path='survey' element={<Survey title={otherTitle} />} />
                    <Route path='enrollment' element={<Enrollment title={otherTitle} />} />
                    <Route path='report' element={<Report title={otherTitle} />} />
                    <Route path='dashboard' element={<Dashboard title={otherTitle} />} />
                    <Route path='costestimate' element={<CostEstimate title={otherTitle} />} />
                    <Route path='coordinator' element={<Coordinator title={otherTitle} />} />
                    <Route path='schooldashboard' element={<SchoolDashboard title={otherTitle} />} />
                    <Route path='managedistrict' element={<ManageDistrict title={otherTitle} />} />
                </Route>
            </Route>
            <Route path="/tableau" element={<WdcConnector />} />
            <Route path='ts/:urlcode' element={<SurveySelection title={surveyTitle} />} />
            <Route path='pdf_schooldashboard' element={<PDFSchoolDashboard />} />
            <Route path={`pdfenrollment`} element={<PDFEnrollment />} />
            <Route path={`orderpdf`} element={<PDFReportOrder />} />
            <Route path={`orderpdfmail`} element={<PDFReportOrderMail />} />
            <Route path={`surveypdf`} element={<SurveyPdf />} />
            <Route path={`managedbpdf`} element={<DashboardPdf />} />
            <Route path={`costestimatepdf`} element={<CostEstimatePdf />} />
            <Route path='pdf_schooldashboard' element={<PDFSchoolDashboard />} />
            <Route path='forgotpassword' element={<ForgotPassword title={registerTitle} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />


        </Routes>
    )
}

export default RouterConfig;